const reducer = (state: WtrState, action: { error: string }) => ({
  ...state,
  bookingSlotId: null,
  error: action.error,
});

export default reducer;
